module.exports = function getResource(label, vars = []) {
    let resources = {
        quickLookText: 'Quick Look',
        moreInfoText: `More info on ${vars[0]}`
    };

    return resources[label];
};
